import { State } from '../State';
import { duration } from '../utils/duration';
import { isFirstSession } from '../utils/platform';
import { resurrectionExpiration } from './resurrection.ruleset';
import type { ResurrectionReward } from './resurrection.schema';

/**
 * Check if user hasn't played in the last 30 days.
 * @param state
 * @param now
 */
export function isReactivated(state: State, now: number): boolean {
  const threshold = duration({ days: 30 });

  // User was created less than 30 days ago.
  if (now - state.createdAt < threshold) return false;

  // Is first session, ignore
  if (isFirstSession(state)) return false;

  // User has played in the last 30 days.
  return now - state.previousSessionAt >= threshold;
}

/**
 * Check if user has a valid resurrection item to claim.
 */
export function hasResurrectionRewardToClaim(
  state: State,
  item: ResurrectionReward,
  now: number,
): boolean {
  // Retrieve the timestamp of the resurrection item
  const timestamp = state.resurrection?.[item];
  // If there is no timestamp, the item cannot be claimed
  if (!timestamp) return false;
  // Check if the resurrection reward is still valid (not expired)
  return timestamp > now - resurrectionExpiration;
}
